var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 8.66659H8V5.33325M3.33333 2.33325L4.66667 1.33325M12.6667 2.33325L11.3333 1.33325M8 14.6666C8.78793 14.6666 9.56815 14.5114 10.2961 14.2099C11.0241 13.9083 11.6855 13.4664 12.2426 12.9092C12.7998 12.3521 13.2417 11.6906 13.5433 10.9627C13.8448 10.2347 14 9.45452 14 8.66659C14 7.87865 13.8448 7.09844 13.5433 6.37048C13.2417 5.64253 12.7998 4.9811 12.2426 4.42394C11.6855 3.86679 11.0241 3.42484 10.2961 3.12331C9.56815 2.82178 8.78793 2.66659 8 2.66659C6.4087 2.66659 4.88258 3.29873 3.75736 4.42394C2.63214 5.54916 2 7.07529 2 8.66659C2 10.2579 2.63214 11.784 3.75736 12.9092C4.88258 14.0344 6.4087 14.6666 8 14.6666Z",
    stroke: "#001535",
    strokeOpacity: 0.3,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloackIcon);
export default __webpack_public_path__ + "static/media/cloackIcon.c0371ea018880e3462652f121dcab103.svg";
export { ForwardRef as ReactComponent };